import { useCallback, useState } from "react";

import { useAPINFE2 } from "hooks";

export const useInvoiceEscriturationTotals = () => {
  const apiNfe = useAPINFE2();
  const [data, setData] = useState(undefined);
  const [totalPages, setTotalPages] = useState(undefined);
  const [loading, setLoading] = useState(true);

  const fetch = useCallback(
    (params = {}) => {
      setLoading(true);
      apiNfe
        .post("/nfe/escrituracao/notas/totais", {
          ...params,
        })
        .then(values => {
          setTotalPages(values?.data?.total_pages);
          setData(values?.data?.data);
          setLoading(false);
        })
        .catch(() => {
          setData(undefined);
          setTotalPages(undefined);
          setLoading(false);
        });
    },
    [apiNfe],
  );

  return { isLoading: loading, data, totalPages, fetch };
};

export const useInvoiceEscriturationSearching = () => {
  const apiNfe = useAPINFE2();
  const [data, setData] = useState(undefined);
  const [loading, setLoading] = useState(true);

  const {
    isLoading: isLoadingTotals,
    data: dataTotals,
    totalPages,
    fetch: fetchTotals,
  } = useInvoiceEscriturationTotals();

  const fetch = useCallback(
    (params = {}) => {
      setLoading(true);
      apiNfe
        .post("nfe/escrituracao/notas", {
          ...params,
        })
        .then(values => {
          fetchTotals({ ...params });
          setData(values?.data);
          setLoading(false);
        })
        .catch(() => {
          setData(undefined);
          setLoading(false);
        });
    },
    [apiNfe, fetchTotals],
  );

  return {
    isLoading: loading,
    data,
    dataTotals: dataTotals?.[0],
    totalPages,
    isLoadingTotals,
    fetch,
  };
};
